/**
 * @file lib/password-rules.ts
 * @description antd Form 密碼校驗規則（序50/51，2026-09-25）。
 *
 * 規則本體統一取自 `@zhcb/shared` 的 `validatePasswordPolicy`，與後端 zod schema 同源：
 * - `userPasswordRule`：使用者自行設定（修改密碼 / 忘記密碼重設）→ 6–10 字元、英數混合。
 * - `adminPasswordRule`：管理員設定（建立帳號初始密碼 / 重設密碼）→ 同上，另允許
 *   系統預設初始密碼 1234567890。
 */

import type { FormRule } from 'antd';
import { DEFAULT_INITIAL_PASSWORD, validatePasswordPolicy } from '@zhcb/shared';

/** 使用者自行設定密碼的校驗規則（空值交由 required 規則處理） */
export const userPasswordRule: FormRule = {
  validator: (_rule, value: unknown) => {
    if (typeof value !== 'string' || value === '') return Promise.resolve();
    const error = validatePasswordPolicy(value);
    return error ? Promise.reject(new Error(error)) : Promise.resolve();
  },
};

/** 管理員設定密碼的校驗規則（允許預設初始密碼例外；空值交由 required 規則處理） */
export const adminPasswordRule: FormRule = {
  validator: (_rule, value: unknown) => {
    if (typeof value !== 'string' || value === '' || value === DEFAULT_INITIAL_PASSWORD) {
      return Promise.resolve();
    }
    const error = validatePasswordPolicy(value);
    return error ? Promise.reject(new Error(error)) : Promise.resolve();
  },
};
